import React, { Component } from "react";
import { Form, Input, InputNumber, Tooltip } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
import GenerickModal from "../../buttons/genericModal";
import { backendPostWithoutRefresh } from "../../../helpers/callBackend";
import ImageUpload from "./uploadImage";
import GenerateCode from "../../formItems/generateCode";
import LoadingButton from '@mui/lab/LoadingButton';

class UnitBankAccountCheckDeposits extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			submitting: false,
			CheckDeposits: [],
			verificationToken: "",
			idempotencyKey: uuidv4(),
			check_images_back: "",
			check_images_front: "",
		};
		this.formRef = React.createRef();
	}

	handleVerificatonCode = async (values) => {
		this.setState({ ...this.state, verificationToken: values.verificationToken, verificationCode: values.verificationCode  });
	};

	onCheckSubmit = (formData) => {
		var data = { ...formData };
		data["check_images_back"] = this.state.check_images_back;
		data["check_images_front"] = this.state.check_images_front;
		data["account_id"] = this.props.bankAccountId;
		data["idempotencyKey"] = this.state.idempotencyKey;
		data["verificationToken"] = this.state.verificationToken;
		this.setState({ submitting: true });
		backendPostWithoutRefresh("/api/payments/check-deposit/", data)
			.then((response) => {
				this.props.updateCheckDeposits(response.data);
				if (this.formRef.current) {
					this.formRef.current.resetFields();
				}
				this.setState({
					visible: false,
					submitting: false,
					idempotencyKey: uuidv4(),
				});
			})
			.catch(() => {
				this.setState({ submitting: false });
			})
	};

	render() {
		const userPermission = localStorage.getItem("arpariUserPermission");
		return this.props.bankAccountInfo.has_check_deposits ? (
			userPermission === "RO" ?
			<Tooltip title="Not permitted. Please check permission with your admin.">
                <a disabled style={{ cursor: "not-allowed" }}>Deposit Checks <ArrowRightOutlined /></a>
            </Tooltip>
			  :
			<GenerickModal
				size="md"
				visible={this.state.visible}
				handleCancelModal={() => {
					if (this.formRef.current) {
						this.formRef.current.resetFields();
					}
					this.setState({ ...this.state, visible: false });
				}}
				showModal={() => this.setState({ ...this.state, visible: true })}
				button={
					<a
						onClick={() => this.onClick(this.props.bankAccountId)}
						style={{ fontWeight: "400", fontSize: "14px" }}>
						Deposit Checks <ArrowRightOutlined />
					</a>
				}
				modalTitle="Deposit Check"
				modalBody={
					<>
						<Form
							layout="vertical"
							name="basic"
							onFinish={this.onCheckSubmit}
							autoComplete="off"
							ref = {this.formRef}
							>
							<Form.Item
								label="Amount"
								name="amount"
								rules={[{ required: true, message: "Please input amount" }]}>
								<InputNumber
									placeholder="amount"
									formatter={(value) =>
										`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
									}
									parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
									style={{ width: "100%" }}
								/>
							</Form.Item>

							<Form.Item
								label="Description"
								name="description"
								rules={[
									{ required: true, message: "Please input description" },
								]}>
								<Input placeholder="description" />
							</Form.Item>

							<Form.Item
								label="Check images front side"
								name="check_images_front">
								<ImageUpload
									onChange={(data) => {
										let newState = this.state;
										newState["check_images_front"] = data;
										this.setState(newState);
									}}
								/>
							</Form.Item>

							<Form.Item
								label="Check images back side"
								name="check_images_back">
								<ImageUpload
									onChange={(data) => {
										let newState = this.state;
										newState["check_images_back"] = data;
										this.setState(newState);
									}}
								/>
							</Form.Item>
							<GenerateCode
                bankAccountId={this.props.bankAccountId}
                onChange={this.handleVerificatonCode}
              />
							<Form.Item>
								<LoadingButton
									disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
									sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
									htmlType="submit"
									loadingPosition="start"
									loading={this.state.submitting}
									style={{ margin: "3px", width: "100%" }}
									>
									Submit
								</LoadingButton>
							</Form.Item>
						</Form>
					</>
				}
			/>
		) : (
			<>
				<Tooltip title="Coming Soon">
					<a disabled>
						Deposit Checks <ArrowRightOutlined />
					</a>
				</Tooltip>
			</>
		);
	}
}

export default UnitBankAccountCheckDeposits;
